import { render } from "./list-forum.vue?vue&type=template&id=e80aa7d0&ts=true"
import script from "./list-forum.vue?vue&type=script&lang=ts"
export * from "./list-forum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__